import Layout from '../views/layout/Layout'

export default {
  path: '/device',
  component: Layout,
  redirect: '/device/supplier',
  name: 'device',
  meta: {title: '设备管理', icon: 'device'},
  children: [
    {
      path: 'supplier',
      name: 'supplier',
      component: () => import('@/views/device/supplier/index'),
      meta: {title: '供应商列表', icon: 'supplier'}
    },
    {
      path: 'hardware',
      name: 'hardware',
      component: () => import('@/views/device/hardware/index'),
      meta: {title: '硬件列表', icon: 'hardware'}
    },
    {
      path: 'hardware/edit',
      name: 'deviceEdit',
      component: () => import('@/views/device/hardware/edit'),
      meta: {title: '录入设备', icon: 'hardware'},
      hidden: true
    }
  ]
}


// WEBPACK FOOTER //
// ./src/router/device.js